module.exports = __webpack_public_path__ + "media/images/logo-utees-shop-07d3c1e1d9e16ad9e61ba4228dfcecfc.svg";